import { Injectable } from '@angular/core';
import type { BarcodeRequest, RenderResult } from '../types/barcodes';

@Injectable({ providedIn: 'root' })
export class BarcodeRendererService {
  async render(request: BarcodeRequest): Promise<RenderResult> {
    if (request.symbology === 'qr') {
      const { default: QRCode } = await import('qrcode');
      const canvas = document.createElement('canvas');
      await QRCode.toCanvas(canvas, request.value, {
        width: request.width || 256,
        margin: 1,
      });
      const pngBlob = await new Promise<Blob | null>(resolve => canvas.toBlob(resolve)) as Blob;
      return { canvas, pngBlob };
    }

    if (request.symbology === 'datamatrix') {
      const { toCanvas } = await import('@bwip-js/browser');
      const canvas = document.createElement('canvas');
      await toCanvas(canvas, {
        bcid: 'datamatrix',
        text: request.value,
        scale: 2,
        height: request.height || 20,
        includetext: request.displayValue || false,
        textxalign: 'center',
      } as any);
      const pngBlob = await new Promise<Blob | null>(resolve => canvas.toBlob(resolve)) as Blob;
      return { canvas, pngBlob };
    }

    // 1D barcodes via JsBarcode
    const JsBarcode = (await import('jsbarcode')).default as any;
    const canvas = document.createElement('canvas');
    const options: any = {
      format: this.mapFormat(request.symbology),
      width: 2,
      height: request.height || 60,
      displayValue: request.displayValue ?? true,
      text: request.text,
      margin: 4,
    };
    JsBarcode(canvas, request.value, options);
    const pngBlob = await new Promise<Blob | null>(resolve => canvas.toBlob(resolve)) as Blob;
    return { canvas, pngBlob };
  }

  private mapFormat(sym: string): string {
    switch (sym) {
      case 'code128': return 'CODE128';
      case 'code39': return 'CODE39';
      case 'itf': return 'ITF';
      case 'ean13': return 'EAN13';
      case 'ean8': return 'EAN8';
      case 'upca': return 'UPC';
      case 'upce': return 'UPC';
      default: return 'CODE128';
    }
  }
}


